import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Rnd } from "react-rnd";
import "./CruiseControl.css";
const CruiseControl = ({ isActive, onClose, onSet, onStop }) => {
    const { t } = useTranslation();
    return (_jsx(Rnd, { default: {
            x: 20,
            y: 100,
            width: 250,
            height: "auto",
        }, enableResizing: false, dragHandleClassName: "drag-handle", style: {
            zIndex: 10000,
        }, children: _jsxs("div", { className: "cruise-control", children: [_jsx("div", { className: "drag-handle cruise-control-header", children: _jsx("div", { onClick: onClose, className: "close-drone" }) }), _jsx("div", { className: "cruise-control-body", children: isActive ? (_jsxs(_Fragment, { children: [_jsx("p", { className: "cruise-control-text", children: t("cruiseControl.activeHint") }), _jsx("button", { className: "btn", onClick: onStop, children: t("cruiseControl.stop") })] })) : (_jsxs(_Fragment, { children: [_jsx("p", { className: "cruise-control-text", children: t("cruiseControl.hint") }), _jsx("button", { className: "btn", onClick: onSet, children: t("cruiseControl.set") })] })) })] }) }));
};
export default CruiseControl;
